import type { ErrorState } from './state'

/**
 * Initialization specific error.
 *
 * Requires that an initialization error state is given at construction time.
 */
export class InitError {
  errorState: ErrorState

  /**
   * @constructor
   * @param m A human-readable error message (not user-facing).
   * @param errorState An error state enum member describing the error.
   */
  constructor(errorState: ErrorState) {
    this.errorState = errorState
  }

  /**
   * Returns the initialization error state associated with the error.
   * @return Initialization error state.
   */
  getErrorState(): ErrorState {
    return this.errorState
  }
}
